"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2831],{

/***/ 7399:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AA": function() { return /* binding */ ButtonFilterCatalog; },
/* harmony export */   "CE": function() { return /* binding */ ButtonFilterPersons; },
/* harmony export */   "UX": function() { return /* binding */ ButtonOrderingCatalog; },
/* harmony export */   "bd": function() { return /* binding */ ButtonShowMore; }
/* harmony export */ });
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(917);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1463);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5944);


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



function ButtonOrderingCatalog(_ref) {
  var isActive = _ref.isActive,
      callback = _ref.callback,
      children = _ref.children;
  var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_0__.u)();
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("button", {
    css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)({
      color: isActive ? theme.colors.text : '#ccc',
      fontWeight: isActive ? 700 : 400,
      fontFamily: 'Golos',
      cursor: 'pointer',
      ':hover': {
        fontFamily: 'Montserrat',
        fontWeight: 700,
        color: theme.colors.text
      }
    },  true ? "" : 0,  true ? "" : 0),
    onClick: callback,
    type: "button",
    children: children
  });
}
function ButtonFilterCatalog(_ref2) {
  var isActive = _ref2.isActive,
      callback = _ref2.callback,
      children = _ref2.children;
  var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_0__.u)();
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("button", {
    css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)({
      padding: 10,
      lineHeight: '5px',
      background: isActive ? '#f44336' : 'none',
      borderRadius: 3,
      color: isActive ? theme.colors.white : '#333',
      transition: 'all 0.2s ease, box-shadow 0.4s ease',
      cursor: 'pointer'
    },  true ? "" : 0,  true ? "" : 0),
    type: "button",
    onClick: callback,
    children: children
  });
}

var _ref4 =  true ? {
  name: "1jotg8x",
  styles: "width:220px;background:#ff4a2e;background-image:linear-gradient(120deg, #ff4a2e 0%, #de2839 100%);box-shadow:0px 0px 10px 0px rgba(0, 0, 0, 0.25);padding:9px 25px;font-size:12px;font-weight:500;border-radius:24px;background-size:500% 500%;color:#fff;display:flex;justify-content:center;align-items:center;cursor:pointer"
} : 0;

function ButtonFilterPersons(_ref3) {
  var callback = _ref3.callback,
      children = _ref3.children;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("button", {
    css: _ref4,
    type: "button",
    onClick: callback,
    children: children
  });
}

var _ref6 =  true ? {
  name: "wyfeef",
  styles: "width:100%;background:#dfdfdf;height:45px;border-radius:4px;padding:0 0.8em;font-size:1rem;font-family:Golos;font-weight:500;white-space:normal;border:2px solid #dfdfdf;cursor:pointer;text-decoration:none;color:#000;line-height:41px;display:inline-flex;align-items:center;justify-content:center;transition:all 0.2s ease;:hover{background:inherit;}"
} : 0;

function ButtonShowMore(_ref5) {
  var callback = _ref5.callback,
      _ref5$loadingText = _ref5.loadingText,
      loadingText = _ref5$loadingText === void 0 ? '' : _ref5$loadingText;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("button", {
    onClick: function onClick() {
      callback();
    },
    type: "button",
    css: _ref6,
    children: loadingText || 'Показать больше'
  });
}

/***/ }),

/***/ 4775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W": function() { return /* binding */ CompilationPage; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(917);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(7812);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(29);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(7794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.js + 1 modules
var emotion_element_c39617d8_browser_esm = __webpack_require__(1463);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./utils/viewed.js
var utils_viewed = __webpack_require__(6339);
// EXTERNAL MODULE: ./lib/api/http.js
var http = __webpack_require__(1377);
// EXTERNAL MODULE: ./lib/api/urls.ts
var urls = __webpack_require__(4154);
// EXTERNAL MODULE: ./lib/consts.ts
var consts = __webpack_require__(9006);
// EXTERNAL MODULE: ./components/blocks/BreadCrumbs.tsx
var BreadCrumbs = __webpack_require__(9013);
// EXTERNAL MODULE: ./components/styled/typography.js
var typography = __webpack_require__(2068);
// EXTERNAL MODULE: ./node_modules/react-responsive-carousel/lib/js/index.js
var js = __webpack_require__(615);
// EXTERNAL MODULE: ./components/picture/picture.tsx
var picture = __webpack_require__(2786);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(5944);
;// CONCATENATED MODULE: ./components/compilation-slider/compilation-slider.tsx




function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var _ref2 =  true ? {
  name: "7cfx2l",
  styles: "position:absolute;bottom:0;right:0;width:100%;height:100%;background:linear-gradient(180deg, rgba(19, 19, 19, 0) 25.52%, #131313 100%);z-index:1"
} : 0;

var _ref3 =  true ? {
  name: "nyfdx3",
  styles: "margin-bottom:3rem"
} : 0;

function CompilationSlider(_ref) {
  var _css3;

  var images = _ref.images,
      compilation = _ref.compilation;
  var theme = (0,emotion_element_c39617d8_browser_esm.u)();

  var mapSlides = function mapSlides() {
    var slides = (0,toConsumableArray/* default */.Z)(images);

    if (images !== null && images !== void 0 && images.length) {
      slides = slides.filter(function (item) {
        return !item.is_main;
      });
      slides = slides.map(function (slide, index) {
        var _css2;

        return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((_css2 = {
            width: '100%',
            height: '570px',
            position: 'relative',
            color: theme.colors.textWhite,
            transition: 'opacity .5s ease',
            borderRadius: '0 0 4px 4px',
            overflow: 'hidden',
            img: {
              position: 'absolute',
              bottom: 0,
              right: 0,
              overflow: 'hidden',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: '100%',
              maxWidth: '100%',
              height: '100%',
              objectFit: 'cover'
            }
          }, (0,defineProperty/* default */.Z)(_css2, consts/* DEVICE_SCREENS_MAX_STRING.lg */.fD.lg, {
            height: '317px'
          }), (0,defineProperty/* default */.Z)(_css2, consts/* DEVICE_SCREENS_MAX_STRING.md */.fD.md, {
            height: '384px',
            img: {
              objectFit: 'cover',
              height: '100%',
              top: 0,
              left: 0,
              transform: 'none'
            }
          }), _css2),  true ? "" : 0,  true ? "" : 0),
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(picture/* Image */.Ee, {
            image: slide,
            loading: index === 0 ? 'eager' : 'lazy',
            alt: compilation.title
          }, "img__".concat(slide.id)), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: _ref2
          })]
        }, slide.id);
      });
    }

    return slides;
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    css: _ref3,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(js/* Carousel */.lr, {
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((_css3 = {
        overflow: 'hidden',
        maxHeight: '570px',
        display: 'flex',
        borderRadius: '0 0 4px 4px',
        boxShadow: '0 0 5px #ccc',
        border: '5px solid #fff'
      }, (0,defineProperty/* default */.Z)(_css3, consts/* DEVICE_SCREENS_MAX_STRING.lg */.fD.lg, {
        maxHeight: '317px'
      }), (0,defineProperty/* default */.Z)(_css3, consts/* DEVICE_SCREENS_MAX_STRING.md */.fD.md, {
        maxHeight: '396px'
      }), _css3),  true ? "" : 0,  true ? "" : 0),
      showThumbs: false,
      showStatus: false,
      infiniteLoop: true,
      showArrows: false,
      children: mapSlides()
    })
  });
}
// EXTERNAL MODULE: ./components/layout/Container.tsx
var Container = __webpack_require__(7135);
// EXTERNAL MODULE: ./components/blocks/ShareBlock.tsx
var ShareBlock = __webpack_require__(2863);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react-timer-hook/dist/index.js
var dist = __webpack_require__(3751);
// EXTERNAL MODULE: ./node_modules/luxon/src/luxon.js + 23 modules
var luxon = __webpack_require__(120);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./public/img/redRouble.svg
var redRouble = __webpack_require__(5629);
// EXTERNAL MODULE: ./public/img/when.svg
var when = __webpack_require__(1245);
// EXTERNAL MODULE: ./public/img/location.svg
var img_location = __webpack_require__(1271);
// EXTERNAL MODULE: ./public/img/views2.svg
var views2 = __webpack_require__(3148);
// EXTERNAL MODULE: ./public/img/star-outline.svg
var star_outline = __webpack_require__(7581);
// EXTERNAL MODULE: ./public/img/pushkin.svg
var pushkin = __webpack_require__(7890);
// EXTERNAL MODULE: ./utils/index.tsx
var utils = __webpack_require__(6535);
// EXTERNAL MODULE: ./constants/events.ts
var events = __webpack_require__(6880);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
;// CONCATENATED MODULE: ./components/actions/styled.tsx



var _excluded = ["text", "title"],
    _excluded2 = ["children"],
    _excluded3 = ["children"];

function styled_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




function LabelFeatureListItem(_ref) {
  var text = _ref.text,
      title = _ref.title,
      restProps = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var theme = (0,emotion_element_c39617d8_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", _objectSpread(_objectSpread({
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
      display: 'block',
      textAlign: 'center',
      marginRight: '6px',
      background: theme.colors.red,
      borderRadius: '2px',
      fontFamily: 'Golos',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: '13px',
      lineHeight: '100%',
      color: theme.colors.white,
      padding: '4px 10px'
    },  true ? "" : 0,  true ? "" : 0),
    title: title
  }, restProps), {}, {
    children: text
  }));
}
function ActionButton(_ref2) {
  var _objectSpread3;

  var children = _ref2.children,
      onButtonClick = _ref2.onButtonClick,
      bookButton = _ref2.bookButton;
  var theme = (0,emotion_element_c39617d8_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
    onClick: onButtonClick,
    type: "button",
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(_objectSpread(_objectSpread((0,defineProperty/* default */.Z)({
      fontFamily: 'Golos',
      fontSize: 16,
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '16px',
      letterSpacing: '0em',
      background: theme.colors.buttonRed,
      borderRadius: 4,
      display: 'inline-block',
      padding: 10,
      textAlign: 'center',
      color: theme.colors.white,
      cursor: 'pointer',
      transition: 'all 0.2s ease, box-shadow 0.4s ease',
      '&:hover': {
        boxShadow: "0px 0px 10px 0px ".concat(theme.colors.gradient)
      }
    }, consts/* DEVICE_SCREENS_MAX_STRING.xl */.fD.xl, {
      padding: 9,
      width: '100%'
    }), bookButton ? (0,defineProperty/* default */.Z)({}, consts/* DEVICE_SCREENS_MIN_STRING.lg */.zg.lg, {
      width: 200
    }) : {}), {}, (_objectSpread3 = {}, (0,defineProperty/* default */.Z)(_objectSpread3, consts/* DEVICE_SCREENS_MAX_STRING.md */.fD.md, {
      padding: 9,
      width: '100%'
    }), (0,defineProperty/* default */.Z)(_objectSpread3, consts/* DEVICE_SCREENS_MAX_STRING.sm */.fD.sm, {
      padding: 9,
      width: '100%'
    }), _objectSpread3)),  true ? "" : 0,  true ? "" : 0),
    children: children
  });
}
function ActionLabelItem(_ref4) {
  var children = _ref4.children,
      restProps = (0,objectWithoutProperties/* default */.Z)(_ref4, _excluded2);

  var theme = (0,emotion_element_c39617d8_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", _objectSpread(_objectSpread({
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
      width: '100px',
      height: '34px',
      fontSize: '13px',
      fontWeight: 600,
      color: theme.colors.white,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: '0 4px 10px 0 rgba(0, 0, 0, 0.1)'
    },  true ? "" : 0,  true ? "" : 0)
  }, restProps), {}, {
    children: children
  }));
}

var _ref6 =  true ? {
  name: "vhuutz",
  styles: "display:flex;line-height:1.3;max-height:32px;overflow:hidden;&>svg{flex:0 0 auto;margin-right:5px;}"
} : 0;

function DescriptionItem(_ref5) {
  var children = _ref5.children,
      restProps = (0,objectWithoutProperties/* default */.Z)(_ref5, _excluded3);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", _objectSpread(_objectSpread({
    css: _ref6
  }, restProps), {}, {
    children: children
  }));
}
// EXTERNAL MODULE: ./components/styled/Link.tsx
var Link = __webpack_require__(6196);
// EXTERNAL MODULE: ./utils/event.js
var utils_event = __webpack_require__(923);
// EXTERNAL MODULE: ./components/favorite/FavoriteButton.tsx + 3 modules
var FavoriteButton = __webpack_require__(7344);
// EXTERNAL MODULE: ./models/favorite.ts
var favorite = __webpack_require__(494);
// EXTERNAL MODULE: ./components/favorite/FavoriteButtonCardWrapper.tsx
var FavoriteButtonCardWrapper = __webpack_require__(146);
// EXTERNAL MODULE: ./models/action.ts
var action = __webpack_require__(193);
// EXTERNAL MODULE: ./utils/utm.ts
var utm = __webpack_require__(74);
;// CONCATENATED MODULE: ./components/actions/ActionCardColumn.tsx



function ActionCardColumn_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

function ActionCardColumn_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ActionCardColumn_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ActionCardColumn_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ActionCardColumn_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





























var ActionCardColumn_ref2 =  true ? {
  name: "cb6ynt",
  styles: "position:absolute;top:30px;left:0;z-index:1;display:flex;flex-direction:row;font-family:Golos"
} : 0;

var ActionCardColumn_ref3 =  true ? {
  name: "d0at3l",
  styles: "background:#FFFFFF;opacity:0.8;border-radius:0px 4px 4px 0px;height:34px;width:36px;display:flex;flex-direction:row;justify-content:center;align-items:center;svg{transform:scale(0.8);}"
} : 0;

var _ref4 =  true ? {
  name: "1pi274v",
  styles: "width:100%;background:rgba(0, 0, 0, 0.7);color:#fff;padding:6px 0;z-index:10;position:absolute;left:0;bottom:0"
} : 0;

var _ref5 =  true ? {
  name: "lesovd",
  styles: "width:90%;margin:0 auto"
} : 0;

var ActionCardColumn_ref6 =  true ? {
  name: "1cxr13n",
  styles: "text-align:center;font-size:13px"
} : 0;

var _ref7 =  true ? {
  name: "1wox62x",
  styles: "width:100%;height:3px;background:#fff;border-radius:2px;margin-top:5px"
} : 0;

var _ref8 =  true ? {
  name: "1rzhsb9",
  styles: "padding:0;margin:0;position:absolute;top:-7px;left:8px;right:8px;display:flex;justify-content:flex-start;align-items:flex-start"
} : 0;

var _ref9 =  true ? {
  name: "1jks8pm",
  styles: "& span:not(:last-child):after{content:\", \";}"
} : 0;

var _ref10 =  true ? {
  name: "157xhr7",
  styles: "width:16px;height:16px"
} : 0;

var _ref11 =  true ? {
  name: "11jf4ye",
  styles: "display:flex;gap:8px"
} : 0;

var _ref12 =  true ? {
  name: "157xhr7",
  styles: "width:16px;height:16px"
} : 0;

var _ref13 =  true ? {
  name: "157xhr7",
  styles: "width:16px;height:16px"
} : 0;

var _ref14 =  true ? {
  name: "o7nnmj",
  styles: "margin-right:16px"
} : 0;

var _ref15 =  true ? {
  name: "157xhr7",
  styles: "width:16px;height:16px"
} : 0;

var _ref16 =  true ? {
  name: "2jmx4s",
  styles: "display:flex;align-items:center;line-height:1.3;height:16px;margin-left:18px;gap:5px;svg{flex:0 0 auto;}"
} : 0;

var _ref17 =  true ? {
  name: "157xhr7",
  styles: "width:16px;height:16px"
} : 0;

var _ref18 =  true ? {
  name: "157xhr7",
  styles: "width:16px;height:16px"
} : 0;

function ActionCardColumn(_ref) {
  var _objectSpread2, _css3, _css4, _css5, _css6, _css7, _css9;

  var item = _ref.item;
  var theme = (0,emotion_element_c39617d8_browser_esm.u)();
  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)({
    showTimer: false,
    startDate: null,
    endDate: null,
    title: null
  }),
      timerData = _useState[0],
      setTimerData = _useState[1];

  var _useTimer = (0,dist.useTimer)({
    expiryTimestamp: timerData.endDate ? luxon/* DateTime.fromISO */.ou.fromISO(timerData.endDate).valueOf() : new Date().valueOf(),
    onExpire: function onExpire() {
      return console.warn('onExpire called');
    }
  }),
      seconds = _useTimer.seconds,
      minutes = _useTimer.minutes,
      hours = _useTimer.hours,
      days = _useTimer.days,
      restart = _useTimer.restart;

  var _useState2 = (0,react.useState)(0),
      progressValue = _useState2[0],
      setProgressValue = _useState2[1];

  var seoAnalyticsFromButton = (0,utils_event/* useSendMetricsFromButton */.Gc)();
  var utmParams = (0,utm/* extractUtmParams */.S)(router.query);
  (0,react.useEffect)(function () {
    var newTimerData = {
      showTimer: false,
      startDate: null,
      endDate: null,
      title: (0,utils/* getTitleForTimer */.KR)(item.countdown_type)
    };
    var dataPrepareForTimer = null;
    (0,utils/* countdownInit */.Gw)([luxon/* DateTime.fromISO */.ou.fromISO(item.countdown_datetime)], item.countdown_type, function (countdown) {
      dataPrepareForTimer = countdown;
    });

    if (dataPrepareForTimer) {
      newTimerData.showTimer = true;
      newTimerData.endDate = moment_default()().valueOf() + dataPrepareForTimer.date;
      newTimerData.startDate = moment_default()(moment_default()().valueOf() + dataPrepareForTimer.date).subtract(7, 'day');
    }

    if (newTimerData.showTimer) {
      var a = (Number(moment_default()().valueOf()) - Number(newTimerData.startDate.valueOf())) * 100;
      var b = Number(moment_default()(newTimerData.endDate).valueOf()) - Number(newTimerData.startDate.valueOf());
      var newProgressVal = Math.round(a / b);
      setProgressValue(newProgressVal);
      restart(newTimerData.endDate);
    }

    setTimerData(newTimerData);
  }, [item]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    // actions-column__item actions-column__item_compilation
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(ActionCardColumn_objectSpread(ActionCardColumn_objectSpread({}, theme.mixins.col(1)), {}, (_objectSpread2 = {
      marginBottom: 64
    }, (0,defineProperty/* default */.Z)(_objectSpread2, consts/* DEVICE_SCREENS_MAX_STRING.xl */.fD.xl, ActionCardColumn_objectSpread(ActionCardColumn_objectSpread({}, theme.mixins.col(1)), {}, {
      marginBottom: 32
    })), (0,defineProperty/* default */.Z)(_objectSpread2, consts/* DEVICE_SCREENS_MAX_STRING.lg */.fD.lg, ActionCardColumn_objectSpread({}, theme.mixins.col(1))), (0,defineProperty/* default */.Z)(_objectSpread2, consts/* DEVICE_SCREENS_MAX_STRING.md */.fD.md, ActionCardColumn_objectSpread(ActionCardColumn_objectSpread({}, theme.mixins.col(1)), {}, {
      marginBottom: 16
    })), (0,defineProperty/* default */.Z)(_objectSpread2, consts/* DEVICE_SCREENS_MAX_STRING.sm */.fD.sm, ActionCardColumn_objectSpread({}, theme.mixins.col(1))), _objectSpread2)),  true ? "" : 0,  true ? "" : 0),
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      // action-card-column
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
        borderRadius: 4,
        backgroundColor: theme.colors.white,
        position: 'relative',
        top: 0,
        transition: 'all .3s ease',
        '&:hover': (0,defineProperty/* default */.Z)({
          transform: 'translateY(-4px)',
          boxShadow: theme.constants.boxShadow
        }, consts/* DEVICE_SCREENS_MAX_STRING.md */.fD.md, {
          transform: 'none',
          boxShadow: 'none'
        })
      },  true ? "" : 0,  true ? "" : 0),
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Link/* Link */.rU // action-card-column__image-wrapper
      , {
        href: ['', item.city.url, 'actions', item.slug, ''].join('/') // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        ,
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({
          position: 'relative',
          width: 472,
          display: 'block',
          overflow: 'hidden',
          borderRadius: '4px 0 0 4px',
          '&::before': {
            content: "''",
            display: 'block',
            paddingTop: 257
          }
        }, consts/* DEVICE_SCREENS_MAX_STRING.xl */.fD.xl, ActionCardColumn_objectSpread({}, theme.mixins.responsiveBox('75%'))),  true ? "" : 0,  true ? "" : 0),
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          // action-card__label-block
          css: ActionCardColumn_ref2,
          children: [!item.instead_price && !item.filter_price && item.type !== events/* eventTypes.restaurant */.uS.restaurant && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ActionLabelItem // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          , {
            css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
              borderRadius: item.pushkin_card_payment ? '0' : '0 4px 4px 0',
              backgroundColor: theme.colors.red,
              background: 'rgba(0, 102, 204, 0.80)'
            },  true ? "" : 0,  true ? "" : 0),
            children: "\u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E"
          }), !!item.discount && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ActionLabelItem // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          , {
            css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
              borderRadius: item.pushkin_card_payment ? '0' : '0 4px 4px 0',
              backgroundColor: 'rgba(244, 67, 54, 0.80)'
            },  true ? "" : 0,  true ? "" : 0),
            children: ["\u2212", item.discount, "%\xA0\u0441\u043A\u0438\u0434\u043A\u0430"]
          }), !!item.pushkin_card_payment && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ActionLabelItem // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          , {
            css: ActionCardColumn_ref3,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pushkin/* default */.Z, {})
          })]
        }), item.countdown_type && item.countdown_type !== 'unset' && timerData.showTimer && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: _ref4,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: _ref5,
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
              css: ActionCardColumn_ref6,
              children: [timerData.title, ' ', (0,utils/* formatTimer */.NE)(days, hours, minutes, seconds)]
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              css: _ref7,
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
                  height: '100%',
                  width: "".concat(progressValue, "%"),
                  background: 'rgb(244, 67, 54)',
                  borderRadius: 2,
                  marginLeft: -1
                },  true ? "" : 0,  true ? "" : 0)
              })
            })]
          })
        }), item.image && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          // action-card-column__image
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(ActionCardColumn_objectSpread(ActionCardColumn_objectSpread({}, theme.mixins.responsiveBoxInside), {}, {
            '&> img': ActionCardColumn_objectSpread({}, theme.mixins.imageInsideBox)
          }),  true ? "" : 0,  true ? "" : 0),
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(picture/* Picture */.t, {
            initWhiteBlackFilter: item.not_season,
            src: item.image,
            alt: item.title
          })
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("ul", {
        // action-card__label-container-sub
        css: _ref8,
        children: [item.not_season && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LabelFeatureListItem, {
          text: "\u041D\u0435 \u0441\u0435\u0437\u043E\u043D",
          title: "\u041D\u0435 \u0441\u0435\u0437\u043E\u043D"
        }), item.best_reviews && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LabelFeatureListItem, {
          text: "\u043B\u0443\u0447\u0448\u0438\u0435 \u043E\u0442\u0437\u044B\u0432\u044B",
          title: "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438 \u0432\u044B\u0441\u043E\u043A\u043E \u043E\u0446\u0435\u043D\u0438\u0432\u0430\u044E\u0442 \u043C\u0435\u0440\u043E\u043F\u0440\u0438\u044F\u0442\u0438\u0435"
        }), item.hit && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LabelFeatureListItem, {
          text: "\u0445\u0438\u0442",
          title: "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438 \u0447\u0430\u0441\u0442\u043E \u043F\u0440\u043E\u0441\u043C\u0430\u0442\u0440\u0438\u0432\u0430\u044E\u0442 \u044D\u0442\u043E \u043C\u0435\u0440\u043E\u043F\u0440\u0438\u044F\u0442\u0438\u0435"
        }), item.first_time && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LabelFeatureListItem, {
          text: "\u0432\u043F\u0435\u0440\u0432\u044B\u0435",
          title: "\u0421\u043E\u0431\u044B\u0442\u0438\u0435 \u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0432\u043F\u0435\u0440\u0432\u044B\u0435"
        }), item.premiere && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LabelFeatureListItem, {
          text: "\u043F\u0440\u0435\u043C\u044C\u0435\u0440\u0430",
          title: "\u041F\u0440\u0435\u043C\u044C\u0435\u0440\u043D\u044B\u0435 \u043F\u043E\u043A\u0430\u0437\u044B \u043C\u0435\u0440\u043E\u043F\u0440\u0438\u044F\u0442\u0438\u044F"
        }), item.prepayment && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LabelFeatureListItem, {
          text: "\u043F\u0440\u0435\u0434\u043E\u043F\u043B\u0430\u0442\u0430",
          title: "\u041E\u043D\u043B\u0430\u0439\u043D \u0432\u044B \u0432\u043D\u043E\u0441\u0438\u0442\u0435 \u0442\u043E\u043B\u044C\u043A\u043E \u043F\u0440\u0435\u0434\u043E\u043F\u043B\u0430\u0442\u0443"
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FavoriteButtonCardWrapper/* default */.Z, {
        compilationCard: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FavoriteButton/* default */.Z, {
          kind: favorite/* FavoriteKinds.event */.f.event,
          id: item.remote_id,
          size: "small",
          variant: "red-outline"
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        // action-card-column__info
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((_css3 = {
          position: 'absolute',
          top: 0,
          left: '472px',
          right: 0,
          bottom: 0,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          padding: 20
        }, (0,defineProperty/* default */.Z)(_css3, consts/* DEVICE_SCREENS_MAX_STRING.xl */.fD.xl, {
          position: 'static',
          padding: '20px 20px 12px'
        }), (0,defineProperty/* default */.Z)(_css3, consts/* DEVICE_SCREENS_MAX_STRING.sm */.fD.sm, {
          padding: '14px 14px 8px'
        }), _css3),  true ? "" : 0,  true ? "" : 0),
        children: [item.reservation_count_text && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          // action-card-column__description_reservation_count_text
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
            fontFamily: 'Golos',
            fontSize: 14,
            fontWeight: 500,
            lineHeight: '20px',
            letterSpacing: '0em',
            color: theme.colors.red
          },  true ? "" : 0,  true ? "" : 0),
          children: item.reservation_count_text
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.rU // action-card-column__title
        , {
          href: ['', item.city.url, 'actions', item.slug, ''].join('/') // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          ,
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((_css4 = {
            fontFamily: 'Montserrat',
            fontSize: '18px',
            fontStyle: 'normal',
            fontWeight: 700,
            lineHeight: '22px',
            letterSpacing: '0em',
            width: 'calc(100% - 130px)',
            textDecoration: 'none',
            display: 'inline-block',
            '&:hover': {
              color: theme.colors.black
            }
          }, (0,defineProperty/* default */.Z)(_css4, consts/* DEVICE_SCREENS_MAX_STRING.xl */.fD.xl, {
            width: '100%'
          }), (0,defineProperty/* default */.Z)(_css4, consts/* DEVICE_SCREENS_MAX_STRING.md */.fD.md, {
            width: '100%'
          }), (0,defineProperty/* default */.Z)(_css4, consts/* DEVICE_SCREENS_MAX_STRING.sm */.fD.sm, {
            maxHeight: 'initial',
            marginBottom: '10px',
            minHeight: '69px',
            display: 'flex',
            alignItems: 'center'
          }), _css4),  true ? "" : 0,  true ? "" : 0),
          children: item.title
        }), !!item.short_description && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((_css5 = {
            fontFamily: 'Golos',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '20px',
            letterSpacing: '0em',
            paddingRight: 40,
            paddingBottom: 5,
            '> div': {
              maxHeight: 70,
              overflow: 'hidden'
            }
          }, (0,defineProperty/* default */.Z)(_css5, consts/* DEVICE_SCREENS_MAX_STRING.xl */.fD.xl, {
            paddingRight: 0,
            height: 'auto',
            paddingBottom: 10
          }), (0,defineProperty/* default */.Z)(_css5, consts/* DEVICE_SCREENS_MAX_STRING.md */.fD.md, {
            paddingRight: 0,
            height: 'auto',
            paddingBottom: 10,
            '> div': {
              maxHeight: 80,
              overflow: 'hidden'
            }
          }), (0,defineProperty/* default */.Z)(_css5, consts/* DEVICE_SCREENS_MAX_STRING.sm */.fD.sm, {
            paddingRight: 0,
            height: 'auto',
            paddingBottom: 10,
            '> div': {
              maxHeight: 160,
              overflow: 'hidden'
            }
          }), _css5),  true ? "" : 0,  true ? "" : 0),
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            children: item.short_description.length > 200 ? item.short_description.slice(0, 200).concat('...') : item.short_description
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          // action-card-column__description
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((_css6 = {
            display: 'flex',
            justifyContent: 'space-between',
            gap: 15,
            color: theme.colors.black,
            fontSize: 13,
            fontWeight: 500
          }, (0,defineProperty/* default */.Z)(_css6, consts/* DEVICE_SCREENS_MAX_STRING.xl */.fD.xl, {
            flexDirection: 'column',
            gap: 0
          }), (0,defineProperty/* default */.Z)(_css6, '> div > div:not(:last-child) ', {
            marginBottom: 5
          }), _css6),  true ? "" : 0,  true ? "" : 0),
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            children: [item.type !== events/* eventTypes.restaurant */.uS.restaurant && !!item.dates_txt && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DescriptionItem // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            , {
              css: _ref9,
              children: item.has_further_dates && item.dates_txt ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(when/* default */.Z, {
                  css: _ref10
                }), item.dates_txt]
              }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                css: _ref11,
                children: item.date_unknown && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(when/* default */.Z, {
                    css: _ref12
                  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                    children: "\u0414\u0430\u0442\u0430 \u0443\u0442\u043E\u0447\u043D\u044F\u0435\u0442\u0441\u044F"
                  })]
                })
              })
            }), item.type !== events/* eventTypes.restaurant */.uS.restaurant && !!item.filter_price && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DescriptionItem, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(redRouble/* default */.Z, {
                css: _ref13
              }), !!item.instead_price && !!item.filter_price && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                title: "\u0412\u0430\u0448\u0430 \u044D\u043A\u043E\u043D\u043E\u043C\u0438\u044F ".concat((0,utils/* splitPriceByThree */.ax)((0,utils/* getBenefit */.yM)(item.instead_price, item.filter_price)), "\u20BD"),
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                  children: ["\u043E\u0442 ", (0,utils/* splitPriceByThree */.ax)(item.filter_price), " "]
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  content: "RUB",
                  children: ["\u0440\u0443\u0431\u043B\u0435\u0439 \u0432\u043C\u0435\u0441\u0442\u043E ", (0,utils/* splitPriceByThree */.ax)(item.instead_price)]
                })]
              }), !!item.filter_price && !item.instead_price && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                children: [item.display_price && item.display_price.indexOf('от') !== -1 ? 'от ' : '', (0,utils/* splitPriceByThree */.ax)(item.filter_price), " \u0440\u0443\u0431\u043B\u0435\u0439"]
              })]
            }), item.place_title && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DescriptionItem, {
              css: _ref14,
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(img_location/* default */.Z, {
                fill: theme.colors.red,
                css: _ref15
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                children: item.place_title
              })]
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((_css7 = {
              marginTop: 'auto',
              position: 'relative',
              bottom: 0,
              right: 0
            }, (0,defineProperty/* default */.Z)(_css7, consts/* DEVICE_SCREENS_MAX_STRING.xl */.fD.xl, {
              position: 'static',
              padding: '16px 0'
            }), (0,defineProperty/* default */.Z)(_css7, consts/* DEVICE_SCREENS_MAX_STRING.sm */.fD.sm, {
              position: 'static',
              padding: '16px 0'
            }), _css7),  true ? "" : 0,  true ? "" : 0),
            children: [item.age_category && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({
                fontFamily: 'Golos',
                fontStyle: 'normal',
                fontWeight: 500,
                fontSize: 13,
                textAlign: 'right',
                marginBottom: 16,
                color: theme.colors.grayStrong
              }, consts/* DEVICE_SCREENS_MAX_STRING.xl */.fD.xl, {
                display: 'none'
              }),  true ? "" : 0,  true ? "" : 0),
              children: item.age_category
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ActionButton, {
              bookButton: item.type !== action/* ACTION_TYPES.FREE */.aI.FREE,
              onButtonClick: function onButtonClick() {
                seoAnalyticsFromButton.onSend(item);
                router.push({
                  pathname: ['', item.city.url, 'actions', item.slug, ''].join('/'),
                  query: ActionCardColumn_objectSpread({
                    order: ''
                  }, utmParams.utmObject)
                });
              },
              children: (0,utils_event/* getBuyButtonText */.A)(item, false, true)
            })]
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          // action-card-column__misc
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((_css9 = {
            position: 'absolute',
            right: 20,
            top: 20,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            color: theme.colors.grayStrong,
            fontFamily: 'Golos',
            fontSize: 12,
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '16px',
            letterSpacing: '0.01em',
            gap: 18
          }, (0,defineProperty/* default */.Z)(_css9, consts/* DEVICE_SCREENS_MAX_STRING.xl */.fD.xl, {
            position: 'static',
            padding: 0,
            width: '100%'
          }), (0,defineProperty/* default */.Z)(_css9, consts/* DEVICE_SCREENS_MAX_STRING.sm */.fD.sm, {
            position: 'static',
            padding: 0,
            width: '100%'
          }), _css9),  true ? "" : 0,  true ? "" : 0),
          children: [item.comments_avg_rating > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: _ref16,
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(star_outline/* default */.Z, {
              css: _ref17
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
              children: item.comments_avg_rating.toFixed(1)
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
              display: 'flex',
              alignItems: 'center',
              height: '16px',
              fontFamily: 'Golos',
              fontSize: '12px',
              fontStyle: 'normal',
              fontWeight: 500,
              lineHeight: '16px',
              letterSpacing: '0.01em',
              color: theme.colors.grayStrong,
              svg: {
                flex: '0 0 auto',
                marginRight: '5px'
              }
            },  true ? "" : 0,  true ? "" : 0),
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(views2/* default */.Z, {
              fill: theme.colors.grayStrong,
              css: _ref18
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
              children: item.views
            })]
          }), item.age_category && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({
              fontFamily: 'Golos',
              fontStyle: 'normal',
              fontWeight: 500,
              fontSize: 13,
              textAlign: 'right',
              marginLeft: 'auto',
              display: 'none',
              color: theme.colors.grayStrong
            }, consts/* DEVICE_SCREENS_MAX_STRING.xl */.fD.xl, {
              display: 'block'
            }),  true ? "" : 0,  true ? "" : 0),
            children: item.age_category
          })]
        })]
      })]
    })
  });
}
// EXTERNAL MODULE: ./components/compilations/compilations.tsx
var compilations = __webpack_require__(4306);
// EXTERNAL MODULE: ./components/viewed/viewed.tsx
var viewed_viewed = __webpack_require__(5705);
// EXTERNAL MODULE: ./components/about/Subscription.tsx
var Subscription = __webpack_require__(6911);
// EXTERNAL MODULE: ./components/about/MobileApps.tsx + 3 modules
var MobileApps = __webpack_require__(8556);
// EXTERNAL MODULE: ./components/common/UpButton.tsx + 1 modules
var UpButton = __webpack_require__(7406);
// EXTERNAL MODULE: ./components/collapsable/collapsable.tsx + 1 modules
var collapsable = __webpack_require__(4052);
// EXTERNAL MODULE: ./components/Buttons.js
var Buttons = __webpack_require__(7399);
// EXTERNAL MODULE: ./components/styled/Button.tsx
var Button = __webpack_require__(7601);
// EXTERNAL MODULE: ./utils/consts.ts
var utils_consts = __webpack_require__(8575);
// EXTERNAL MODULE: ./lib/api/browserStorage.ts
var browserStorage = __webpack_require__(6343);
;// CONCATENATED MODULE: ./components/pages/compilation/CompilationPage.tsx





function CompilationPage_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



function CompilationPage_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CompilationPage_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CompilationPage_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CompilationPage_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




























var CompilationPage_ref3 =  true ? {
  name: "mbsl7l",
  styles: "font-family:Golos;display:flex;align-items:center;gap:5px;margin:20px 10%;color:#888;font-weight:500"
} : 0;

var CompilationPage_ref4 =  true ? {
  name: "11a2h7u",
  styles: "width:20px;height:18px;fill:#BFC1C3"
} : 0;

var CompilationPage_ref5 =  true ? {
  name: "tm108a",
  styles: "display:flex;flex-direction:column;justify-content:flex-start;align-items:flex-end;margin-right:10%;margin-bottom:15px;text-align:right;span{margin-right:5px;}"
} : 0;

function CompilationPage(_ref) {
  var _div, _css3, _css4;

  var currentCity = _ref.currentCity,
      compilation = _ref.compilation,
      initialEventsList = _ref.initialEventsList,
      compilationsList = _ref.compilationsList;
  var theme = (0,emotion_element_c39617d8_browser_esm.u)();

  var _useState = (0,react.useState)({
    results: []
  }),
      viewed = _useState[0],
      setViewed = _useState[1];

  var _useState2 = (0,react.useState)(null),
      eventsList = _useState2[0],
      setEventsList = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isLoadingEvents = _useState3[0],
      setIsLoadingEvents = _useState3[1];

  var _useState4 = (0,react.useState)(1),
      page = _useState4[0],
      setPage = _useState4[1];

  (0,react.useEffect)(function () {
    setPage(1);
    setEventsList(initialEventsList);
  }, [compilation.id]);

  var showMoreEvents = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var newEventsList;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!eventsList) {
                _context.next = 8;
                break;
              }

              setIsLoadingEvents(true);
              _context.next = 4;
              return http/* http.get */.d.get(urls.V4.events, {
                ids: compilation.events,
                status: events/* activeStatus */.cT,
                is_web: 'true',
                limit: utils_consts/* COMPILATION_EVENTS_COUNT */.uR,
                offset: page * utils_consts/* COMPILATION_EVENTS_COUNT */.uR
              }, null, {
                arrayFormat: 'comma'
              });

            case 4:
              newEventsList = _context.sent;
              setEventsList(CompilationPage_objectSpread(CompilationPage_objectSpread({}, newEventsList), {}, {
                results: eventsList.results.concat(newEventsList.results)
              }));
              setPage(page + 1);
              setIsLoadingEvents(false);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function showMoreEvents() {
      return _ref2.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    http/* http.post */.d.post(urls.V2.eventViews, {
      Compilation: compilation.remote_id
    });
  }, [compilation.id]);
  (0,react.useEffect)(function () {
    function fetch() {
      return _fetch.apply(this, arguments);
    }

    function _fetch() {
      _fetch = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
        var viewedList;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return (0,utils_viewed/* fetchViewed */.F)();

              case 2:
                viewedList = _context2.sent;
                setViewed(viewedList);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _fetch.apply(this, arguments);
    }

    fetch();
    var viewedActions = [];
    viewedActions = (JSON.parse((0,browserStorage/* getLocalStorageItem */.l)('viewed-events') || '[]') || []).slice(0, 8) || [];
    (0,browserStorage/* setLocalStorageItem */.D)('viewed-events', JSON.stringify((0,toConsumableArray/* default */.Z)(viewedActions)));
  }, [compilation.id]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container/* Container */.W, {
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({
      padding: '16px 12px'
    }, consts/* DEVICE_SCREENS_MAX_STRING.md */.fD.md, {
      padding: '28px 8px 0 8px'
    }),  true ? "" : 0,  true ? "" : 0),
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
        '> div': (_div = {}, (0,defineProperty/* default */.Z)(_div, consts/* DEVICE_SCREENS_MAX_STRING.md */.fD.md, {
          display: 'inline-flex'
        }), (0,defineProperty/* default */.Z)(_div, consts/* DEVICE_SCREENS_MAX_STRING.sm */.fD.sm, {
          display: 'none'
        }), _div)
      },  true ? "" : 0,  true ? "" : 0),
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BreadCrumbs/* BreadCrumbs */.b, {
        currentCity: currentCity,
        items: [{
          title: 'Подборки',
          url: '/compilations/'
        }, {
          title: compilation.title
        }]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(typography.H1, {
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((_css3 = {
          width: '100%',
          textAlign: 'center',
          fontFamily: 'Montserrat',
          lineHeight: '38px',
          letterSpacing: '0.01em',
          color: theme.colors.text,
          fontWeight: 700,
          fontSize: 32,
          marginTop: 16,
          marginBottom: '4rem'
        }, (0,defineProperty/* default */.Z)(_css3, consts/* DEVICE_SCREENS_MAX_STRING.md */.fD.md, {
          textAlign: 'left',
          marginTop: '1.5rem',
          marginBottom: '2rem',
          fontSize: 32
        }), (0,defineProperty/* default */.Z)(_css3, consts/* DEVICE_SCREENS_MAX_STRING.sm */.fD.sm, {
          margin: '0.75em 0 0.75em',
          fontSize: 22,
          lineHeight: '26px'
        }), _css3),  true ? "" : 0,  true ? "" : 0),
        children: compilation.title
      })]
    }), compilation.images.length > 0 && !(compilation.images.length === 1 && compilation.images[0].is_main) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompilationSlider, {
      images: compilation.images,
      compilation: compilation
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((_css4 = {
        fontFamily: 'Golos',
        fontSize: 24,
        lineHeight: '150%',
        textAlign: 'center',
        padding: '0 10%',
        color: '#000000',
        display: 'block',
        fontWeight: 300,
        marginBottom: '2rem'
      }, (0,defineProperty/* default */.Z)(_css4, consts/* DEVICE_SCREENS_MAX_STRING.xl */.fD.xl, {
        fontSize: 20
      }), (0,defineProperty/* default */.Z)(_css4, consts/* DEVICE_SCREENS_MAX_STRING.lg */.fD.lg, {
        fontWeight: 800
      }), (0,defineProperty/* default */.Z)(_css4, consts/* DEVICE_SCREENS_MAX_STRING.md */.fD.md, {
        fontSize: 16,
        lineHeight: '140%',
        padding: '0 7%'
      }), (0,defineProperty/* default */.Z)(_css4, consts/* DEVICE_SCREENS_MAX_STRING.sm */.fD.sm, {
        fontSize: 13,
        lineHeight: '140%',
        padding: '0 1%',
        fontWeight: 600
      }), _css4),  true ? "" : 0,  true ? "" : 0),
      children: compilation.lead_text
    }), !!compilation.views && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: CompilationPage_ref3,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(views2/* default */.Z, {
        css: CompilationPage_ref4
      }), ' ', compilation.views]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: CompilationPage_ref5,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ShareBlock/* ShareBlock */.T, {
        item: compilation
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("main", {
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
        fontFamily: 'Golos',
        color: theme.colors.black
      },  true ? "" : 0,  true ? "" : 0),
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(CompilationPage_objectSpread(CompilationPage_objectSpread({
          marginBottom: '4rem'
        }, theme.mixins.row()), {}, (0,defineProperty/* default */.Z)({}, consts/* DEVICE_SCREENS_MAX_STRING.md */.fD.md, {
          marginBottom: '2rem'
        })),  true ? "" : 0,  true ? "" : 0),
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          // actions-column
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(CompilationPage_objectSpread({}, theme.mixins.flex()),  true ? "" : 0,  true ? "" : 0),
          children: eventsList ? eventsList.results.map(function (item) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ActionCardColumn, {
              item: item
            }, "actionCardHorizontal".concat(item.id));
          }) : initialEventsList.results.map(function (item) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ActionCardColumn, {
              item: item
            }, "actionCardHorizontal".concat(item.id));
          })
        }), eventsList && eventsList.next && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({
            width: '100%',
            display: 'flex',
            gap: 10,
            padding: '0 8px'
          }, consts/* DEVICE_SCREENS_MAX_STRING.md */.fD.md, {
            paddingTop: 10
          }),  true ? "" : 0,  true ? "" : 0),
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Buttons/* ButtonShowMore */.bd, {
            callback: showMoreEvents,
            loadingText: isLoadingEvents ? 'Загрузка...' : ''
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* StandardButton */.K3, {
            callback: function callback() {
              return window.scrollTo(0, 0);
            },
            children: "\u041D\u0430\u0432\u0435\u0440\u0445"
          })]
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(compilations/* Compilations */.y, {
        title: "\u0414\u0440\u0443\u0433\u0438\u0435 \u043F\u043E\u0434\u0431\u043E\u0440\u043A\u0438",
        compilations: compilationsList,
        currentCity: currentCity,
        href: ['', currentCity.url, 'compilations', ''].join('/')
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(viewed_viewed/* Viewed */.E, {
        title: "\u0412\u044B \u0441\u043C\u043E\u0442\u0440\u0435\u043B\u0438",
        viewed: viewed
      }), compilation.description && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({
          marginBottom: 60
        }, consts/* DEVICE_SCREENS_MAX_STRING.xl */.fD.xl, {
          paddingTop: '2rem'
        }),  true ? "" : 0,  true ? "" : 0),
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(collapsable/* CropText */.Oq, {
          text: compilation.description,
          deskTopCount: 1000,
          mobileCount: 1000
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: 16,
          marginBottom: '4rem'
        }, consts/* DEVICE_SCREENS_MAX_STRING.xl */.fD.xl, {
          gridTemplateColumns: '1fr',
          marginBottom: '2rem'
        }),  true ? "" : 0,  true ? "" : 0),
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Subscription/* Subscription */.w, {
          currentCity: currentCity
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileApps/* MobileApps */._, {})]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UpButton/* UpButton */.e, {
        screenCount: 1.5
      })]
    })]
  });
}

/***/ }),

/***/ 1613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _hocs_createIcon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7267);

var OKIcon = (0,_hocs_createIcon__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    color: '#f2720c',
    networkName: 'ok',
    path: 'M39,30c-1,0-3,2-7,2s-6-2-7-2c-1.1,0-2,0.9-2,2c0,1,0.6,1.5,1,1.7c1.2,0.7,5,2.3,5,2.3l-4.3,5.4   c0,0-0.8,0.9-0.8,1.6c0,1.1,0.9,2,2,2c1,0,1.5-0.7,1.5-0.7S32,39,32,39c0,0,4.5,5.3,4.5,5.3S37,45,38,45c1.1,0,2-0.9,2-2   c0-0.6-0.8-1.6-0.8-1.6L35,36c0,0,3.8-1.6,5-2.3c0.4-0.3,1-0.7,1-1.7C41,30.9,40.1,30,39,30z M32,15c-3.9,0-7,3.1-7,7s3.1,7,7,7c3.9,0,7-3.1,7-7S35.9,15,32,15z M32,25.5   c-1.9,0-3.5-1.6-3.5-3.5c0-1.9,1.6-3.5,3.5-3.5c1.9,0,3.5,1.6,3.5,3.5C35.5,23.9,33.9,22.5,35,22.5z ',
});
/* harmony default export */ __webpack_exports__["Z"] = (OKIcon);


/***/ }),

/***/ 4276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _hocs_createIcon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7267);

var TelegramIcon = (0,_hocs_createIcon__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    color: '#37aee2',
    networkName: 'telegram',
    path: 'm45.90873,15.44335c-0.6901,-0.0281 -1.37668,0.14048 -1.96142,0.41265c-0.84989,0.32661 -8.63939,3.33986 -16.5237,6.39174c-3.9685,1.53296 -7.93349,3.06593 -10.98537,4.24067c-3.05012,1.1765 -5.34694,2.05098 -5.4681,2.09312c-0.80775,0.28096 -1.89996,0.63566 -2.82712,1.72788c-0.23354,0.27218 -0.46884,0.62161 -0.58825,1.10275c-0.11941,0.48114 -0.06673,1.09222 0.16682,1.5716c0.46533,0.96052 1.25376,1.35737 2.18443,1.71383c3.09051,0.99037 6.28638,1.93508 8.93263,2.8236c0.97632,3.44171 1.91401,6.89571 2.84116,10.34268c0.30554,0.69185 0.97105,0.94823 1.65764,0.95525l-0.00351,0.03512c0,0 0.53908,0.05268 1.06412,-0.07375c0.52679,-0.12292 1.18879,-0.42846 1.79109,-0.99212c0.662,-0.62161 2.45836,-2.38812 3.47683,-3.38552l7.6736,5.66477l0.06146,0.03512c0,0 0.84989,0.59703 2.09312,0.68132c0.62161,0.04214 1.4399,-0.07726 2.14229,-0.59176c0.70766,-0.51626 1.1765,-1.34683 1.396,-2.29506c0.65673,-2.86224 5.00979,-23.57745 5.75257,-27.00686l-0.02107,0.08077c0.51977,-1.93157 0.32837,-3.70159 -0.87096,-4.74991c-0.60054,-0.52152 -1.2924,-0.7498 -1.98425,-0.77965l0,0.00176zm-0.2072,3.29069c0.04741,0.0439 0.0439,0.0439 0.00351,0.04741c-0.01229,-0.00351 0.14048,0.2072 -0.15804,1.32576l-0.01229,0.04214l-0.00878,0.03863c-0.75858,3.50668 -5.15554,24.40802 -5.74203,26.96472c-0.08077,0.34417 -0.11414,0.31959 -0.09482,0.29852c-0.1756,-0.02634 -0.50045,-0.16506 -0.52679,-0.1756l-13.13468,-9.70175c4.4988,-4.33199 9.09945,-8.25307 13.744,-12.43229c0.8218,-0.41265 0.68483,-1.68573 -0.29852,-1.70681c-1.04305,0.24584 -1.92279,0.99564 -2.8798,1.47502c-5.49971,3.2626 -11.11882,6.13186 -16.55882,9.49279c-2.792,-0.97105 -5.57873,-1.77704 -8.15298,-2.57601c2.2336,-0.89555 4.00889,-1.55579 5.75608,-2.23009c3.05188,-1.1765 7.01687,-2.7042 10.98537,-4.24067c7.94051,-3.06944 15.92667,-6.16346 16.62028,-6.43037l0.05619,-0.02283l0.05268,-0.02283c0.19316,-0.0878 0.30378,-0.09658 0.35471,-0.10009c0,0 -0.01756,-0.05795 -0.00351,-0.04566l-0.00176,0zm-20.91715,22.0638l2.16687,1.60145c-0.93418,0.91311 -1.81743,1.77353 -2.45485,2.38812l0.28798,-3.98957',
});
/* harmony default export */ __webpack_exports__["Z"] = (TelegramIcon);


/***/ }),

/***/ 4324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _hocs_createIcon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7267);

var VKIcon = (0,_hocs_createIcon__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    color: '#45668e',
    networkName: 'vk',
    path: 'M44.94,44.84h-0.2c-2.17-.36-3.66-1.92-4.92-3.37C39.1,40.66,38,38.81,36.7,39c-1.85.3-.93,3.52-1.71,4.9-0.62,1.11-3.29.91-5.12,0.71-5.79-.62-8.75-3.77-11.35-7.14A64.13,64.13,0,0,1,11.6,26a10.59,10.59,0,0,1-1.51-4.49C11,20.7,12.56,21,14.11,21c1.31,0,3.36-.29,4.32.2C19,21.46,19.57,23,20,24a37.18,37.18,0,0,0,3.31,5.82c0.56,0.81,1.41,2.35,2.41,2.14s1.06-2.63,1.1-4.18c0-1.77,0-4-.5-4.9S25,22,24.15,21.47c0.73-1.49,2.72-1.63,5.12-1.63,2,0,4.84-.23,5.62,1.12s0.25,3.85.2,5.71c-0.06,2.09-.41,4.25,1,5.21,1.09-.12,1.68-1.2,2.31-2A28,28,0,0,0,41.72,24c0.44-1,.91-2.65,1.71-3,1.21-.47,3.15-0.1,4.92-0.1,1.46,0,4.05-.41,4.52.61,0.39,0.85-.75,3-1.1,3.57a61.88,61.88,0,0,1-4.12,5.61c-0.58.78-1.78,2-1.71,3.27,0.05,0.94,1,1.67,1.71,2.35a33.12,33.12,0,0,1,3.92,4.18c0.47,0.62,1.5,2,1.4,2.76C52.66,45.81,46.88,44.24,44.94,44.84Z',
});
/* harmony default export */ __webpack_exports__["Z"] = (VKIcon);


/***/ }),

/***/ 2730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _hocs_createIcon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7267);

var ViberIcon = (0,_hocs_createIcon__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    color: '#7C529E',
    networkName: 'viber',
    path: 'm31.0,12.3c9.0,0.2 16.4,6.2 18.0,15.2c0.2,1.5 0.3,3.0 0.4,4.6a1.0,1.0 0 0 1 -0.8,1.2l-0.1,0a1.1,1.1 0 0 1 -1.0,-1.2l0,0c-0.0,-1.2 -0.1,-2.5 -0.3,-3.8a16.1,16.1 0 0 0 -13.0,-13.5c-1.0,-0.1 -2.0,-0.2 -3.0,-0.3c-0.6,-0.0 -1.4,-0.1 -1.6,-0.8a1.1,1.1 0 0 1 0.9,-1.2l0.6,0l0.0,-0.0zm10.6,39.2a19.9,19.9 0 0 1 -2.1,-0.6c-6.9,-2.9 -13.2,-6.6 -18.3,-12.2a47.5,47.5 0 0 1 -7.0,-10.7c-0.8,-1.8 -1.6,-3.7 -2.4,-5.6c-0.6,-1.7 0.3,-3.4 1.4,-4.7a11.3,11.3 0 0 1 3.7,-2.8a2.4,2.4 0 0 1 3.0,0.7a39.0,39.0 0 0 1 4.7,6.5a3.1,3.1 0 0 1 -0.8,4.2c-0.3,0.2 -0.6,0.5 -1.0,0.8a3.3,3.3 0 0 0 -0.7,0.7a2.1,2.1 0 0 0 -0.1,1.9c1.7,4.9 4.7,8.7 9.7,10.8a5.0,5.0 0 0 0 2.5,0.6c1.5,-0.1 2.0,-1.8 3.1,-2.7a2.9,2.9 0 0 1 3.5,-0.1c1.1,0.7 2.2,1.4 3.3,2.2a37.8,37.8 0 0 1 3.1,2.4a2.4,2.4 0 0 1 0.7,3.0a10.4,10.4 0 0 1 -4.4,4.8a10.8,10.8 0 0 1 -1.9,0.6c-0.7,-0.2 0.6,-0.2 0,0l0.0,0l0,-0.0zm3.1,-21.4a4.2,4.2 0 0 1 -0.0,0.6a1.0,1.0 0 0 1 -1.9,0.1a2.7,2.7 0 0 1 -0.1,-0.8a10.9,10.9 0 0 0 -1.4,-5.5a10.2,10.2 0 0 0 -4.2,-4.0a12.3,12.3 0 0 0 -3.4,-1.0c-0.5,-0.0 -1.0,-0.1 -1.5,-0.2a0.9,0.9 0 0 1 -0.9,-1.0l0,-0.1a0.9,0.9 0 0 1 0.9,-0.9l0.1,0a14.1,14.1 0 0 1 5.9,1.5a11.9,11.9 0 0 1 6.5,9.3c0,0.1 0.0,0.3 0.0,0.5c0,0.4 0.0,0.9 0.0,1.5l0,0l0.0,0.0zm-5.6,-0.2a1.1,1.1 0 0 1 -1.2,-0.9l0,-0.1a11.3,11.3 0 0 0 -0.2,-1.4a4.0,4.0 0 0 0 -1.5,-2.3a3.9,3.9 0 0 0 -1.2,-0.5c-0.5,-0.1 -1.1,-0.1 -1.6,-0.2a1.0,1.0 0 0 1 -0.8,-1.1l0,0l0,0a1.0,1.0 0 0 1 1.1,-0.8c3.4,0.2 6.0,2.0 6.3,6.2a2.8,2.8 0 0 1 0,0.8a0.8,0.8 0 0 1 -0.8,0.7l0,0l0.0,-0.0z',
});
/* harmony default export */ __webpack_exports__["Z"] = (ViberIcon);


/***/ }),

/***/ 9275:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _hocs_createIcon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7267);

var WhatsappIcon = (0,_hocs_createIcon__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    color: '#25D366',
    networkName: 'whatsapp',
    path: 'm42.32286,33.93287c-0.5178,-0.2589 -3.04726,-1.49644 -3.52105,-1.66732c-0.4712,-0.17346 -0.81554,-0.2589 -1.15987,0.2589c-0.34175,0.51004 -1.33075,1.66474 -1.63108,2.00648c-0.30032,0.33658 -0.60064,0.36247 -1.11327,0.12945c-0.5178,-0.2589 -2.17994,-0.80259 -4.14759,-2.56312c-1.53269,-1.37217 -2.56312,-3.05503 -2.86603,-3.57283c-0.30033,-0.5178 -0.03366,-0.80259 0.22524,-1.06149c0.23301,-0.23301 0.5178,-0.59547 0.7767,-0.90616c0.25372,-0.31068 0.33657,-0.5178 0.51262,-0.85437c0.17088,-0.36246 0.08544,-0.64725 -0.04402,-0.90615c-0.12945,-0.2589 -1.15987,-2.79613 -1.58964,-3.80584c-0.41424,-1.00971 -0.84142,-0.88027 -1.15987,-0.88027c-0.29773,-0.02588 -0.64208,-0.02588 -0.98382,-0.02588c-0.34693,0 -0.90616,0.12945 -1.37736,0.62136c-0.4712,0.5178 -1.80194,1.76053 -1.80194,4.27186c0,2.51134 1.84596,4.945 2.10227,5.30747c0.2589,0.33657 3.63497,5.51458 8.80262,7.74113c1.23237,0.5178 2.1903,0.82848 2.94111,1.08738c1.23237,0.38836 2.35599,0.33657 3.24402,0.20712c0.99159,-0.15534 3.04985,-1.24272 3.47963,-2.45956c0.44013,-1.21683 0.44013,-2.22654 0.31068,-2.45955c-0.12945,-0.23301 -0.46601,-0.36247 -0.98382,-0.59548m-9.40068,12.84407l-0.02589,0c-3.05503,0 -6.08417,-0.82849 -8.72495,-2.38189l-0.62136,-0.37023l-6.47252,1.68286l1.73463,-6.29129l-0.41424,-0.64725c-1.70875,-2.71846 -2.6149,-5.85116 -2.6149,-9.07706c0,-9.39809 7.68934,-17.06155 17.15993,-17.06155c4.58253,0 8.88029,1.78642 12.11655,5.02268c3.23625,3.21036 5.02267,7.50812 5.02267,12.06476c-0.0078,9.3981 -7.69712,17.06155 -17.14699,17.06155m14.58906,-31.58846c-3.93529,-3.80584 -9.1133,-5.95471 -14.62789,-5.95471c-11.36055,0 -20.60848,9.2065 -20.61625,20.52564c0,3.61684 0.94757,7.14565 2.75211,10.26282l-2.92557,10.63564l10.93337,-2.85309c3.0136,1.63108 6.4052,2.4958 9.85634,2.49839l0.01037,0c11.36574,0 20.61884,-9.2091 20.62403,-20.53082c0,-5.48093 -2.14111,-10.64081 -6.03239,-14.51915',
});
/* harmony default export */ __webpack_exports__["Z"] = (WhatsappIcon);


/***/ }),

/***/ 7267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ createIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};

function createIcon(iconConfig) {
    var Icon = function (_a) {
        var bgStyle = _a.bgStyle, borderRadius = _a.borderRadius, iconFillColor = _a.iconFillColor, round = _a.round, size = _a.size, rest = __rest(_a, ["bgStyle", "borderRadius", "iconFillColor", "round", "size"]);
        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", __assign({ viewBox: "0 0 64 64", width: size, height: size }, rest),
            round ? (react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: "32", cy: "32", r: "31", fill: iconConfig.color, style: bgStyle })) : (react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", { width: "64", height: "64", rx: borderRadius, ry: borderRadius, fill: iconConfig.color, style: bgStyle })),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: iconConfig.path, fill: iconFillColor })));
    };
    Icon.defaultProps = {
        bgStyle: {},
        borderRadius: 0,
        iconFillColor: 'white',
        size: 64,
    };
    return Icon;
}


/***/ })

}]);